import React from 'react';
import PropTypes from 'prop-types';

import DateField from 'components/form/RecurringForm/components/DatesRangeSelector/DateField';

const DatesRangeSelector = ({ className, t }) => (
  <div className={`${className}`}>
    <p>{t('form.range_dates')}</p>
    <div className="fields-container">
      <DateField extraClassName="field-from" t={t} type="start_from" />

      <DateField extraClassName="field-to" t={t} type="end_on" />
    </div>
  </div>
);

DatesRangeSelector.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
};

DatesRangeSelector.defaultProps = {
  className: '',
  t: () => ({}),
};

export default DatesRangeSelector;
